module.exports = __webpack_public_path__ + "static/media/material.c329feda.svg";